export const serviceArea1 = [
    {
        city: `shenzhen`,
        name: 'Shenzhen Company',
        top: '50.4',
        left: '57.3',
        img: 'images/service/company/shenzhen.png',
    },
    {
        city: `tianjin`,
        name: 'Tianjin Branch',
        top: '25',
        left: '60',
        img: 'images/service/company/tianjin.png',
    },
    {
        city: `dalian`,
        name: 'Dalian Branch',
        top: '26',
        left: '66',
        img: 'images/service/company/dalian.png',
    },
    {
        city: `qingdao`,
        name: 'Qingdao Branch',
        top: '30',
        left: '64',
        img: 'images/service/company/qingdao.png',
    },
    {
        city: `lianyungang`,
        name: 'Lianyungang Branch',
        top: '32',
        left: '63',
        img: 'images/service/company/lianyungang.png',
    },
    {
        city: `shanghai`,
        name: 'Shanghai Branch',
        top: '37.5',
        left: '65',
        img: 'images/service/company/shanghai.png',
    },
    {
        city: `ningbo`,
        name: 'Ningbo Branch',
        top: '40.5',
        left: '65',
        img: 'images/service/company/ningbo.png',
    },
    {
        city: `xiamen`,
        name: 'Xiamen Branch',
        top: '47.5',
        left: '61',
        img: 'images/service/company/xiamen.png',
    },
    {
        city: `guangzhou`,
        name: 'Guangzhou Branch',
        top: '49',
        left: '55',
        img: 'images/service/company/guangzhou.png',
    },
    {
        city: `wuhan`,
        name: 'Wuhan Branch',
        top: '39',
        left: '57',
        img: 'images/service/company/wuhan.png',
    },
    {
        city: `chongqing`,
        name: 'Chongqing Office',
        top: '40',
        left: '48',
        img: 'images/service/company/chongqing.png',
    },
    {
        city: `hunan`,
        name: 'Hunan Branch',
        top: '42',
        left: '54.5',
        img: 'images/service/company/hunan.png',
    },
    {
        city: `vietnam`,
        name: 'Vietnam Branch',
        top: '69',
        left: '47',
        img: 'images/service/company/vietnam.png',
    },
    {
        city: `thailand`,
        name: 'Thailand Branch',
        top: '63',
        left: '40.5',
        img: 'images/service/company/thailand.png',
    },
    {
        city: `malaysia`,
        name: 'Malaysia Branch',
        top: '76',
        left: '42',
        img: 'images/service/company/malaysia.png',
    },
    {
        city: `indonesia`,
        name: 'Indonesia Branch',
        top: '93',
        left: '52',
        img: 'images/service/company/indonesia.png',
    },
    // {
    //     name: '',
    //     top: '',
    //     left: '',
    // },

]
export const serviceArea2 = [
    {
        city: `toronto`,
        name: 'Toronto Branch',
        top: '45',
        left: '77',
    },
    {
        city: `log-angeles`,
        name: 'Los Angeles Branch',
        top: '56',
        left: '43',
        img: 'images/service/company/los-angeles.png',
    },
    {
        city: `new-york`,
        name: 'New York Branch',
        top: '48',
        left: '81',
    },
]

export const serviceWarehouse1 = [
    {
        city: `new-york`,
        name: 'New York',
        top: '49',
        left: '81',
        img: 'images/service/warehouse/1.png',
    },
    {
        city: `los-angeles`,
        name: 'Los Angeles',
        top: '56',
        left: '43',
        img: 'images/service/warehouse/2.png',
    },
    // {
    //     city: `atlanta`,
    //     name: 'Atlanta',
    //     top: '56',
    //     left: '72',
    //     img: 'images/service/warehouse/3.png',
    // },
]

export const serviceWarehouse2 = [
    {
        city: `shenzhen`,
        name: 'Shenzhen',
        top: '77.6',
        left: '65',
        img: 'images/service/warehouse/shenzhen.png',
    },
    {
        city: `qingdao`,
        name: 'Qingdao',
        top: '51',
        left: '75',
        img: 'images/service/warehouse/5.png',
    },
    {
        city: `ningbo`,
        name: 'Ningbo',
        top: '60',
        left: '76',
        img: 'images/service/warehouse/2.png',
    },
    {
        city: `shanghai`,
        name: 'Shanghai',
        top: '64',
        left: '76',
        img: 'images/service/warehouse/3.png',
    },
    {
        city: `guangzhou`,
        name: 'Guangzhou',
        top: '76',
        left: '62.6',
        img: 'images/service/warehouse/4.png',
    },
]